<template>
  <div class="col-sm-12 col-md-6 col-lg-5 mb-3 mb-md-0 w2" v-if="ledger">
    <div class="card h-100">
      <div class="card-header">
        <h2>Account Summary</h2>
      </div>
      <hr width="95%" class="my-0 ml-3" />
      <div class="card-body mt--20">
        <div class="col-sm-12 px-0">
          <div v-if="ledger.length > 0 && transactions[0].Balance != 0">
            <p
              v-if="transactions[0].Balance < 0"
              class="display-32b d-inline-block text-danger mt-2 mb--20"
            >{{Math.abs(transactions[0].Balance) | currency}} in debt</p>
            <p
              v-else-if="transactions[0].Balance > 0"
              class="display-32b d-inline-block text-success mt-2 mb--20"
            >{{transactions[0].Balance | currency}} in credit</p>
            <p
              class="d-inline-block mt--20"
            >&nbsp; as of {{Date.now() | fullDateTime }}</p>
          </div>
          <div v-else>
            <p class="display-32b d-inline-block text-success mt-2 mb--20">£0.00</p>
            <p
              class="d-inline-block mt--20"
            >&nbsp; as of {{Date.now() | fullDateTime }}</p>
          </div>
          <hr />

          <div class="row">
            <div class="col-8">
              <p class="d-inline-block pr-2">Pending transactions:</p>
            </div>
            <div v-if="ledger.length > 1" class="col-4">
              <p
                class="d-inline-block font-weight-bold"
              >{{pendingTransactions | currency}}</p>
            </div>
            <div v-else class="col-4">
              <p class="d-inline-block font-weight-bold">£0.00</p>
            </div>
          </div>
          <hr />

          <div class="row">
            <div class="col-8">
              <p class="d-inline-block pr-2">Last statement balance:</p>
            </div>
            <div v-if="lastBill" class="col-4">
              <p
                v-if="lastBill.ClosingBalance < 0"
                class="d-inline-block font-weight-bold text-danger"
              >{{Math.abs(lastBill.ClosingBalance) | currency}} in debt</p>
              <p
                v-else-if="lastBill.ClosingBalance >= 0"
                class="d-inline-block font-weight-bold text-success"
              >{{lastBill.ClosingBalance | currency}} in credit</p>
            </div>
            <div v-else class="col-4">
              <p class="d-inline-block font-weight-bold text-success">£0.00</p>
            </div>
          </div>
          <hr />

          <div class="row">
            <div class="col-8">
              <p class="d-inline-block pr-2">Last payment:</p>
            </div>
            <div v-if="ledger.length > 1" class="col-4">
              <p
                class="d-inline-block font-weight-bold"
                v-if="lastPayment && lastPayment.Description === 'Opening Balance'"
              >N/A</p>
              <p
                v-else
                class="d-inline-block font-weight-bold"
              >{{(lastPayment && lastPayment.Created) | moment("from", "now")}}</p>
            </div>
            <div v-else class="col-4">
              <p class="d-inline-block font-weight-bold">N/A</p>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-8">
              <p class="d-inline-block pr-2">Unbilled Usage:</p>
            </div>
            <div v-if="usage" class="col-4">
              <!-- <p class="d-inline-block font-weight-bold">£115.50</p> -->
              <!-- THIS IS THE LOGIC FROM THE OLD WIDGET I HAVE AMENDED THE CSS SO SHOULD JUST WORK -->
              <p
                v-if="usage.Total >= 100"
                class="d-inline-block font-weight-bold text-danger"
              >{{usage.Total | currency}}</p>
              <p
                v-else-if="usage.Total < 100 && usage.Total > 0"
                class="d-inline-block font-weight-bold"
              >{{usage.Total | currency}}</p>
              <p
                v-else
                class="d-inline-block font-weight-bold"
              >{{usage.Total | currency}}</p>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-8">
              <p class="d-inline-block pr-2">Last billed day:</p>
            </div>
            <div class="col-4" v-if="lastBill">
              <!-- Logic needs to be <25 days is black, 25-35 days is amber, >35 days is red -->
              <p
                v-if="diff(this.lastBill.PeriodEnds) > 35"
                class="font-weight-bold text-danger"
              >{{diff(this.lastBill.PeriodEnds) | suffix}}</p>
              <p
                v-else-if="diff(this.lastBill.PeriodEnds) < 25"
              >{{diff(this.lastBill.PeriodEnds) | suffix}}</p>
              <p
                v-else
                class="font-weight-bold text-warning"
              >{{diff(this.lastBill.PeriodEnds) | suffix}}</p>
            </div>
          </div>
          
          <hr />

          <div class="row">
            <div class="col-8"><p>Collection Due: </p></div>
            <div class="col-4 js-editable">
              <p>
                {{ collectionDueDays }} days
                <i class="pointer fas fa-edit" @click="edit"></i>
              </p>
              <div class="input-group align-items-center" style="display: none;">
                  <input v-model.number="collectionDueDays" type="number" step="1" required="required" class="prefix w-50">
                  <div class="input-group-prepend ml-2"> Days</div>
              </div>
            </div>
          </div>
          
          <hr />

          <div class="row">
            <div class="col-8"><p>Payment Due:</p></div>
              <div class="col-4 js-editable">
                <p>
                {{ paymentDueDays }} days
                <i class="pointer fas fa-edit" @click="edit"></i>
                </p>
                <div class="input-group align-items-center" style="display: none;">
                  <input  v-model.number="paymentDueDays" type="number" step="1" required="required" class="prefix w-50">
                  <div class="input-group-prepend ml-2"> Days</div>
                </div>
            </div>
          </div>

          <button type="submit" class="btn btn-hc mb-0 float-right mb-2" style="display: none;" @click="save" :disabled="!collectionDueDays || !paymentDueDays">
            Save
          </button>
          <!-- Issue HC#223 new feature for services that are currently not set to bill -->
          <!-- Start -->
          <!-- <hr>
          <div class="row">
            <div class="col-12">
              <p class="text-danger">Please note: Services are currently set to not bill.</p>
            </div>
          </div>-->
          <!-- Finish -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { _ } from 'underscore';
import filters from '@/mixins/filters.js';

export default {
  mixins: [filters],
  data() {
    return {
      collectionDueDaysTemp: undefined,
      paymentDueDaysTemp: undefined,
    };
  },
  methods: {
    diff: function(billedDate) {
      return moment().diff(billedDate, 'days');
    },
    edit(ev) {
      ev.srcElement.parentElement.style.display = 'none';
      ev.srcElement.parentElement.nextSibling.style.display = 'flex';
      this.$el.querySelector('button').style.display = 'flex';
    },
    async save() {
      this.$el.querySelector('button').style.display = 'none';
      this.$el.querySelectorAll('.js-editable').forEach((el) => {
        el.children[0].style.display = 'block';
        el.children[1].style.display = 'none';
      });

      const CollectionDueDays = this.collectionDueDays;
      const PaymentDueDays = this.paymentDueDays;

      try {
        const path = `https://${
          Vue.config.honeycomb.moneybot.domain
        }/api/v1/Accounts/${this.$store.state.customers.account.Id}`;
        await this.$http.put(
          path,
          {
            ...this.$store.state.customers.account,
            CollectionDueDays,
            PaymentDueDays,
          },
          { withCredentials: true }
        );
        this.$snotify.success(`Success! Account updated.`);
      } catch (error) {
        this.$snotify.error(`${error.response.data.UserDescription}`, {
          timeout: 0,
          closeOnClick: true,
        });
      } finally {
        this.$store.dispatch('getAccount', {
          AccountId: this.$store.state.customers.account.Id,
        });
        this.collectionDueDays = undefined;
        this.paymentDueDays = undefined;
      }
    },
  },
  computed: {
    usage() {
      return this.$store.state.finances.usage;
    },
    ledger() {
      return this.$store.state.finances.ledger;
    },
    bills() {
      return _.sortBy(
        this.$store.state.finances.bills,
        'StatementNumber'
      ).reverse();
    },
    lastBill() {
      return _.findWhere(this.bills, { Status: 'Committed' });
    },
    transactions() {
      return _.filter(this.ledger, function(dates) {
        return dates.Created <= moment().format();
      });
    },
    scheduledTransactions() {
      return _.filter(this.ledger, function(dates) {
        return dates.Created >= moment().format();
      });
    },
    pendingTransactions() {
      var balanceChange = 0;
      this.scheduledTransactions.forEach((transactions) => {
        balanceChange += transactions.BalanceChange;
      });
      return balanceChange;
    },
    lastPayment() {
      return _.findWhere(this.transactions, {
        Category: 'Bank',
        Type: 'Credit',
      });
    },
    collectionDueDays: {
      get() {
        if (!this.$store.state.customers.account) return;

        if (this.collectionDueDaysTemp != null ) return this.collectionDueDaysTemp;
        const honeycombConfig =
          (Vue.config && Vue.config.honeycomb) ||
          (this.$config && this.$config.honeycomb) ||
          {};
        const moneybotDefaults = honeycombConfig.moneybot || {};

        return (
          this.collectionDueDaysTemp ||
          this.$store.state.customers.account.CollectionDueDays ||
          moneybotDefaults.defaultCollectionDueDays
        );
      },
      set(val) {
        this.collectionDueDaysTemp = val;
      },
    },
    paymentDueDays: {
      get() {
        if (!this.$store.state.customers.account) return;
        if (this.paymentDueDaysTemp  != null ) return this.paymentDueDaysTemp;
        const honeycombConfig =
          (Vue.config && Vue.config.honeycomb) ||
          (this.$config && this.$config.honeycomb) ||
          {};
        const moneybotDefaults = honeycombConfig.moneybot || {};

        return (
          this.paymentDueDaysTemp ||
          this.$store.state.customers.account.PaymentDueDays ||
          moneybotDefaults.defaultPaymentDueDays
        );
      },
      set(val) {
        this.paymentDueDaysTemp = val;
      },
    },
  },
};
</script>
